import type { ReactNode } from "react";

import { Icon, IconButton } from "@flare/ui/components";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/Funnel/base/Dialog";

import { LssIntroDialogContent } from "./lss-intro-dialog-content";
import { sendOpenChangeEvent } from "./send-open-change-event";

export function LssIntroDialogTrigger({ children }: { children: ReactNode }) {
  return (
    <Dialog onOpenChange={sendOpenChangeEvent}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-2xl px-sp-8 py-sp-7">
        <DialogClose asChild className="absolute right-sp-4 top-sp-4">
          <IconButton variant="ghost" size="md">
            <Icon name="xmark" />
          </IconButton>
        </DialogClose>
        <LssIntroDialogContent />
      </DialogContent>
    </Dialog>
  );
}
